import "../chunk-GV6AIHPN.mjs";

// src/auto-confirm/getProvider.ts
function getProvider() {
  if (typeof window === "undefined") {
    return null;
  }
  const provider = window?.phantom?.app;
  if (!provider) {
    return null;
  }
  return provider;
}

// src/auto-confirm/autoConfirmEnable.ts
import { networkIdToInternalCaip, internalCaipToNetworkId } from "@phantom/constants";
async function autoConfirmEnable(params) {
  const provider = await getProvider();
  if (!provider) {
    throw new Error("Provider not found.");
  }
  const transformedParams = params?.chains ? { chains: params.chains.map(networkIdToInternalCaip) } : {};
  const result = await provider.request({
    method: "phantom_auto_confirm_enable",
    params: transformedParams
  });
  return {
    ...result,
    chains: result.chains.map(internalCaipToNetworkId)
  };
}

// src/auto-confirm/autoConfirmDisable.ts
import { internalCaipToNetworkId as internalCaipToNetworkId2 } from "@phantom/constants";
async function autoConfirmDisable() {
  const provider = await getProvider();
  if (!provider) {
    throw new Error("Provider not found.");
  }
  const result = await provider.request({
    method: "phantom_auto_confirm_disable",
    params: {}
  });
  return {
    ...result,
    chains: result.chains.map(internalCaipToNetworkId2)
  };
}

// src/auto-confirm/autoConfirmStatus.ts
import { internalCaipToNetworkId as internalCaipToNetworkId3 } from "@phantom/constants";
async function autoConfirmStatus() {
  const provider = await getProvider();
  if (!provider) {
    throw new Error("Provider not found.");
  }
  const result = await provider.request({
    method: "phantom_auto_confirm_status",
    params: {}
  });
  return {
    ...result,
    chains: result.chains.map(internalCaipToNetworkId3)
  };
}

// src/auto-confirm/autoConfirmSupportedChains.ts
import { internalCaipToNetworkId as internalCaipToNetworkId4 } from "@phantom/constants";
async function autoConfirmSupportedChains() {
  const provider = await getProvider();
  if (!provider) {
    throw new Error("Provider not found.");
  }
  const result = await provider.request({
    method: "phantom_auto_confirm_supported_chains",
    params: {}
  });
  return {
    chains: result.chains.map(internalCaipToNetworkId4)
  };
}

// src/auto-confirm/plugin.ts
var autoConfirm = {
  autoConfirmEnable,
  autoConfirmDisable,
  autoConfirmStatus,
  autoConfirmSupportedChains
};
function createAutoConfirmPlugin() {
  return {
    name: "autoConfirm",
    create: () => autoConfirm
  };
}
export {
  createAutoConfirmPlugin
};
